import CoreSocialShareTools from './CoreSocialShareTools';

export { type CoreSocialShareToolsProps } from './CoreSocialShareTools';
export default CoreSocialShareTools;
